import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

// Cache for z-index calculation to reduce DOM queries
let modalZIndexCache = {
  value: 1050, // Bootstrap modal default
  lastUpdate: 0,
  cacheTime: 100 // Cache for 100ms to reduce forced reflows
}

// Function to get the highest z-index from active modals
const getHighestModalZIndex = () => {
  const now = Date.now()

  // Return cached value if recent
  if (now - modalZIndexCache.lastUpdate < modalZIndexCache.cacheTime) {
    return modalZIndexCache.value
  }

  // Only check visible modals to reduce DOM queries
  const visibleModals = document.querySelectorAll('.modal.show, .Vue-Toastification__container')
  let highestZIndex = 1050 // Bootstrap modal default

  for (const modal of visibleModals) {
    // Get z-index from style attribute first, then computed style
    const styleZIndex = modal.style.zIndex
    let zIndex = 0

    if (styleZIndex) {
      zIndex = parseInt(styleZIndex) || 0
    } else {
      // Fallback to computed style
      const computedStyle = getComputedStyle(modal)
      zIndex = parseInt(computedStyle.zIndex) || 0
    }

    if (zIndex > highestZIndex) {
      highestZIndex = zIndex
    }
  }

  // Update cache
  modalZIndexCache.value = highestZIndex
  modalZIndexCache.lastUpdate = now

  return highestZIndex
}

// Configure SweetAlert with dynamic z-index
const swalOptions = {
  customClass: {
    container: 'custom-swal-container'
  },
  didOpen: () => {
    const swalContainer = document.querySelector('.swal2-container')
    if (swalContainer) {
      const highestZIndex = getHighestModalZIndex()
      swalContainer.style.zIndex = (highestZIndex + 10).toString()
    }
  }
}

Vue.use(VueSweetalert2, swalOptions)
